var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpiBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6248_1328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6888 8L4.35547 11.6667",
    stroke: "#275CE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68848 2V8H14.6885",
    stroke: "#275CE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68848 8C2.68848 8.78793 2.84367 9.56815 3.1452 10.2961C3.44673 11.0241 3.88868 11.6855 4.44584 12.2426C5.00299 12.7998 5.66442 13.2417 6.39238 13.5433C7.12033 13.8448 7.90055 14 8.68848 14C9.47641 14 10.2566 13.8448 10.9846 13.5433C11.7125 13.2417 12.374 12.7998 12.9311 12.2426C13.4883 11.6855 13.9302 11.0241 14.2318 10.2961C14.5333 9.56815 14.6885 8.78793 14.6885 8C14.6885 7.21207 14.5333 6.43185 14.2318 5.7039C13.9302 4.97595 13.4883 4.31451 12.9311 3.75736C12.374 3.20021 11.7125 2.75825 10.9846 2.45672C10.2566 2.15519 9.47641 2 8.68848 2C7.90055 2 7.12033 2.15519 6.39238 2.45672C5.66442 2.75825 5.00299 3.20021 4.44584 3.75736C3.88868 4.31451 3.44673 4.97595 3.1452 5.7039C2.84367 6.43185 2.68848 7.21207 2.68848 8Z",
    stroke: "#275CE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68848 8L12.0218 13",
    stroke: "#275CE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6248_1328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.688477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiBlue);
export default __webpack_public_path__ + "static/media/kpiBlue.f207bf0719d6d0e98676a3b1735111ea.svg";
export { ForwardRef as ReactComponent };